module.exports = {"full":{"All-instruments":"Все инструменты","No-guitar":"Нет гитары"},"details":{"Lesson-Details":"Детали урока","Tablature":"Табулатура"}};